import { render } from "./UserManagement.vue?vue&type=template&id=ff52c76e"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
script.render = render

export default script